import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Protein1 from "./images/Protein-Qty1.png";
import Protein2 from "./images/Protein-Qty2.png";
import Protein3 from "./images/Protein-Qty3.png";
import Hydration1 from "./images/Hyd-Qty1.png";
import Hydration2 from "./images/Hyd-Qty2.png";
import Hydration3 from "./images/Hyd-Qty3.png";
import Preworkout1 from "./images/PW-W-Qty1.png";
import Preworkout2 from "./images/PW-W-Qty2.png";
import Preworkout3 from "./images/PW-W-Qty3.png";
import Greens1 from "./images/Greens-Qty1.png";
import Greens2 from "./images/Greens-Qty2.png";
import Greens3 from "./images/Greens-Qty3.png";
import Creatine1 from "./images/Creatine-Qty1.png";
import Creatine2 from "./images/Creatine-Qty2.png";
import Creatine3 from "./images/Creatine-Qty3.png";
import Collagen1 from "./images/Collagen-Qty1.png";
import Collagen2 from "./images/Collagen-Qty2.png";
import Collagen3 from "./images/Collagen-Qty3.png";
import Fiber1 from "./images/Fiber-Qty1.png";
import Fiber2 from "./images/Fiber-Qty2.png";
import Fiber3 from "./images/Fiber-Qty3.png";
import { formatPrice } from "../Customizer";
const quantityData = {
    protein: {
        type: "bag",
        img: {
            1: Protein1,
            2: Protein2,
            3: Protein3,
        },
        price: {
            1: 4500,
            2: 6500,
            3: 9750,
        },
        full_price: {
            1: 4500,
            2: 9000,
            3: 13500,
        },
        servings: {
            1: "14 servings",
            2: "28 servings",
            3: "42 servings",
        },
        badge: {
            1: "",
            2: "Popular",
            3: "Save 27%",
        },
    },
    hydration: {
        type: "bag",
        img: {
            1: Hydration1,
            2: Hydration2,
            3: Hydration3,
        },
        price: {
            1: 3000,
            2: 6000,
            3: 9000,
        },
        servings: {
            1: "21 on-the-go packs",
            2: "42 on-the-go packs",
            3: "63 on-the-go packs",
        },
        badge: {
            1: "",
            2: "",
            3: "",
        },
        full_price: {
            1: 3000,
            2: 6000,
            3: 9000,
        },
    },
    preworkout: {
        type: "jar",
        img: {
            1: Preworkout1,
            2: Preworkout2,
            3: Preworkout3,
        },
        price: {
            1: 2600,
            2: 5200,
            3: 7800,
        },
        servings: {
            1: "14 servings",
            2: "28 servings",
            3: "42 servings",
        },
        badge: {
            1: "",
            2: "",
            3: "",
        },
        full_price: {
            1: 2600,
            2: 5200,
            3: 7800,
        },
    },
    greens: {
        type: "box",
        img: {
            1: Greens1,
            2: Greens2,
            3: Greens3,
        },
        price: {
            1: 4200,
            2: 8400,
            3: 12600,
        },
        servings: {
            1: "28 on-the-go packs",
            2: "56 on-the-go packs",
            3: "84 on-the-go packs",
        },
        badge: {
            1: "",
            2: "",
            3: "",
        },
        full_price: {
            1: 4200,
            2: 8400,
            3: 12600,
        },
    },
    creatine: {
        type: "jar",
        img: {
            1: Creatine1,
            2: Creatine2,
            3: Creatine3,
        },
        price: {
            1: 2200,
            2: 4400,
            3: 6600,
        },
        servings: {
            1: "28 servings",
            2: "56 servings",
            3: "84 servings",
        },
        badge: {
            1: "",
            2: "",
            3: "",
        },
        full_price: {
            1: 2200,
            2: 4400,
            3: 6600,
        },
    },
    collagen: {
        type: "jar",
        img: {
            1: Collagen1,
            2: Collagen2,
            3: Collagen3,
        },
        price: {
            1: 2200,
            2: 4400,
            3: 6600,
        },
        servings: {
            1: "14 servings",
            2: "28 servings",
            3: "42 servings",
        },
        badge: {
            1: "",
            2: "",
            3: "",
        },
        full_price: {
            1: 2200,
            2: 4400,
            3: 6600,
        },
    },
    fiber: {
        type: "jar",
        img: {
            1: Fiber1,
            2: Fiber2,
            3: Fiber3,
        },
        price: {
            1: 2200,
            2: 4400,
            3: 6600,
        },
        servings: {
            1: "14 servings",
            2: "28 servings",
            3: "42 servings",
        },
        badge: {
            1: "",
            2: "",
            3: "",
        },
        full_price: {
            1: 2200,
            2: 4400,
            3: 6600,
        },
    },
};
const QuantitySelect = ({ quantity, setQuantity, product, prices, }) => {
    return quantityData[product] ? (_jsx("div", { className: "flex gap-1 max-w-full", children: Array.from({ length: 3 }, (_, i) => i + 1).map((i) => (_jsxs("button", { className: "flex flex-col gap-1 w-full outline-none bg-transparent border-none items-center cursor-pointer text-charcoal p-0", onClick: () => setQuantity(i), children: [_jsxs("span", { style: {
                        border: quantity === i ? "2px solid #1E534D" : "2px solid #fff",
                        borderRadius: "4px",
                        padding: "8px 4px",
                    }, className: "flex flex-col w-full  text-center items-center bg-bone relative", children: [_jsx("img", { alt: product, src: quantityData[product].img[i], width: 74, height: 74, style: { borderRadius: "4px" } }), _jsx("span", { className: "type-body-sm font-normal", children: i + " " + quantityData[product].type + `${i > 1 ? "s" : ""}` }), _jsx("span", { className: "type-body-xs", children: quantityData[product].servings[i] }), quantityData[product].badge[i] && (_jsx("span", { style: {
                                borderRadius: "40px",
                            }, className: "type-body-xs font-normal uppercase p-1 text-white bg-court w-4/5 absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2", children: quantityData[product].badge[i] }))] }), prices && (_jsx("span", { className: "type-body-sm  font-normal text-charcoal", children: formatPrice(i > 1 ? prices[2] * i : prices[1]) }))] }))) })) : null;
};
export default QuantitySelect;
